import { render } from "./reception_dash.vue?vue&type=template&id=7ff5ad36"
import script from "./reception_dash.vue?vue&type=script&lang=js"
export * from "./reception_dash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__